import { getToken } from '../token';

export const proxy = (url: string): string => {
  if (url.includes('blob.core.windows.net') && !url.includes('sig=')) {
    return `${process.env.REACT_APP_API_URL}/file/proxy/${btoa(url)}?jwt=${getToken()}`;
  }

  return url;
};
